import ExtraData from '@/models/ExtraData';
import IRetailerVehicleAvailability from '@/models/test-drive/interfaces/retailer-vehicle-availability.d';
import { Dispatch } from 'vuex';

export const addRetailerKeys = (retailer: IRetailerVehicleAvailability, dispatch: Dispatch) => {
  if (!retailer || retailer.retailerId === 0) {
    return;
  }

  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerId', retailer.retailerId.toString()), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerName', retailer.retailerName), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAddressLine1', retailer.address.addressLine1), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAddressTown', retailer.address.town), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAddressCounty', retailer.address.county), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAddressPostcode', retailer.address.postCode), { root: true });
  dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerDistanceInMiles', retailer.distanceInMiles.toString()), { root: true });

  if (retailer.testDriveVehicleId > 0) {
    dispatch('enquiryModule/submitExtraData', new ExtraData('testDriveVehicleId', retailer.testDriveVehicleId.toString()), { root: true });
  }
};

export const removeRetailerKeys = (dispatch: Dispatch) => {
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerId', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerName', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAddressLine1', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAddressTown', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAddressCounty', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAddressPostcode', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'RetailerDistanceInMiles', { root: true });
  dispatch('enquiryModule/submitRemoveExtraData', 'testDriveVehicleId', { root: true });
};
